var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94596 9.32417L2.77533 3.65045C2.41076 2.99806 2.22847 2.67186 2.25919 2.40479C2.286 2.17178 2.40975 1.96085 2.60008 1.82379C2.81824 1.66669 3.19191 1.66669 3.93926 1.66669H5.80161C6.07935 1.66669 6.21823 1.66669 6.34279 1.7068C6.45302 1.74229 6.55463 1.80037 6.64116 1.87732C6.73895 1.96429 6.80944 2.08394 6.95041 2.32325L10.0001 7.50002L13.0498 2.32325C13.1907 2.08394 13.2612 1.96429 13.359 1.87732C13.4455 1.80037 13.5472 1.74229 13.6574 1.7068C13.7819 1.66669 13.9208 1.66669 14.1986 1.66669H16.0609C16.8083 1.66669 17.1819 1.66669 17.4001 1.82379C17.5904 1.96085 17.7142 2.17178 17.741 2.40479C17.7717 2.67186 17.5894 2.99806 17.2248 3.65045L14.0542 9.32417M8.75009 11.6667L10.0001 10.8334V15M8.95842 15H11.0418M13.8303 9.08652C15.9456 11.2019 15.9456 14.6315 13.8303 16.7469C11.7149 18.8622 8.28527 18.8622 6.16992 16.7469C4.05459 14.6315 4.05459 11.2019 6.16992 9.08652C8.28526 6.97119 11.7149 6.97119 13.8303 9.08652Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.ff70b35ac31fb217a09a2038e64cb913.svg";
export { ForwardRef as ReactComponent };